import PlanillaDetalle from "../../apis/PlanillaDetalle";

export default {
  namespaced: true,
  state: {
    itemsPlanilla: [],
    file_planillaDetalle: null,
  },
  mutations: {
    set_itemsPlanilla(state, itemsPlanilla) {
      state.itemsPlanilla = itemsPlanilla;
    },
    set_file_planilla_detalle(state, value) {
      state.file_planillaDetalle = value;
    },
  },
  actions: {
    emptyFilePlanillaDetalle({ commit }, value) {
      commit("set_file_planilla_detalle", value);
    },
    async getItems({ commit, dispatch }, id) {
      return await PlanillaDetalle.getEmpleados(id)
        .then((response) => {
          commit("set_itemsPlanilla", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar registros, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async actualizaEmpleado({ dispatch }, descuento) {
      console.log("entramos a las funciones");
      console.log(descuento);
      return await PlanillaDetalle.actualizaEmpleado(descuento)
        .then((response) => {
          console.log("as");
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "correcto",
            },
            { root: true }
          );
          /*let id = localStorage.getItem('id_planilla');
                                dispatch('getItem', id)*/
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al registrar el descuento.",
          });
        });
    },
    async actualizaBonoEmpleado({ dispatch }, bonos) {
      return await PlanillaDetalle.actualizaBonoEmpleado(bonos)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "correcto",
            },
            { root: true }
          );
          /*let id = localStorage.getItem('id_planilla');
                                dispatch('getItem', id)*/
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al registrar el descuento.",
          });
        });
    },
    async guardaCierra({ dispatch }, items) {
      console.log("actions");
      return await PlanillaDetalle.guardaCierra(items)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se guardo correctamente",
            },
            { root: true }
          );
          let id = localStorage.getItem("id_planilla");
          dispatch("getItems", id);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Error al momento de guardar planilla",
          });
        });
    },
    async calculaCierra({ dispatch }, items) {
      // console.log("calcula");
      return await PlanillaDetalle.calculaCierra(items)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se guardo correctamente",
            },
            { root: true }
          );
          let id = localStorage.getItem("id_planilla");
          dispatch("getItems", id);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Error al momento de guardar planilla",
          });
        });
    },
    async reabrirPlanilla({ dispatch }, items) {
      console.log("calcula");
      return await PlanillaDetalle.reabrirPlanilla(items)
        .then((response) => {
          // console.log(response)
          if (response.status === 210) {
            dispatch(
              "notifications/store_notification",
              {
                type: "error",
                message: response.data.error || "Planilla Pagada",
              },
              { root: true }
            );
          } else {
            dispatch(
              "notifications/store_notification",
              {
                type: "success",
                message: "Se guardo correctamente",
              },
              { root: true }
            );
            let id = localStorage.getItem("id_planilla");
            dispatch("getItems", id);
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Error al momento de guardar planilla",
            },
            { root: true }
          );
        });
    },
    async pagarPlanilla({ dispatch }, pagar) {
      console.log("calcula");
      return await PlanillaDetalle.pagarPlanilla(pagar)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se guardo correctamente",
            },
            { root: true }
          );
          let id = localStorage.getItem("id_planilla");
          dispatch("getItems", id);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Error al momento de guardar planilla",
          });
        });
    },
    async planillaDownload({ commit, dispatch }, id) {
      commit("set_file_planilla_detalle", null);
      return await PlanillaDetalle.planillaDownload(id)
        .then((response) => {
          console.log(response);
          commit("set_file_planilla_detalle", response.data.file_name);
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se descargo el reporte de manera correcta",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch("notifications/store_notification", {
            type: "error",
            message: "Ocurrió un error al descargar reporte",
          });
        });
    },
    async actualizarPlanilla({ commit, dispatch }, id_planilla) {
      return await PlanillaDetalle.actualizarPlanilla(id_planilla)
        .then((response) => {
          commit("set_itemsPlanilla", response.data);
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Actualizado",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al actualizar.",
            },
            { root: true }
          );
        });
    },
  },
};
